import { HierarchyUtils, ComponentIds, Entity } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { removeProducts } from '../utils/removeProducts';

const removeHandleFromSelectedEntity = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) {
    return null;
  }
  const handles = HierarchyUtils.descendants(selectedEntity).filter((child: Entity) => {
    return child.hasComponent(ComponentIds.HANDLE_COMPONENT_ID);
  });

  removeProducts(handles, coreApi, products);
};

export default removeHandleFromSelectedEntity;
